import React from "react";

import Select from "react-select";

import classNames from "classnames";
import { usePaginationContext } from "../contexts/Pagination";

const SelectItemsPerPage = ({
    options = [10, 25, 50, 100],
}: {
    options?: number[];
}) => {
    const { itemsPerPage, setItemsPerPage, setPage } = usePaginationContext();

    return (
        <>
            Show
            <Select
                className={classNames("showEntries")}
                isMulti={false}
                isClearable={false}
                onChange={e => {
                    setItemsPerPage(e?.value || 50);
                    setPage(1);
                }}
                value={{
                    value: itemsPerPage,
                    label: itemsPerPage,
                }}
                defaultValue={{
                    value: itemsPerPage,
                    label: itemsPerPage,
                }}
                options={options.map(o => ({
                    value: o,
                    label: o,
                }))}
            />
            entries
        </>
    );
};

export default SelectItemsPerPage;
